import { TenderContractsAllComponent} from '../../../../../../pages';
import {
    TenderBidsResolver,
    TenderContractBidsAnalysisResolver,
    TenderContractsAllResolver
} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const contractsAllRoute: Route = {
    path: 'all',
    component: TenderContractsAllComponent,
    resolve: {
        //contracts: TenderContractsAllResolver,
    },
};
